import { Report } from '../types';

export const standardReports: Report[] = [
  {
    id: 'customers-report',
    name: 'Customers Report',
    description: 'List of all customers with their details',
    type: 'customers',
    path: '/reports/customers'
  },
  {
    id: 'orders-report',
    name: 'Orders Report',
    description: 'List of all orders with customer information',
    type: 'orders',
    path: '/reports/orders'
  },
  {
    id: 'invoices-report',
    name: 'Invoices Report',
    description: 'List of all invoices with customer information',
    type: 'invoices',
    path: '/reports/invoices'
  },
  {
    id: 'subscriptions-report',
    name: 'Subscriptions Report',
    description: 'List of all subscriptions with customer information',
    type: 'subscriptions',
    path: '/reports/subscriptions'
  },
  {
    id: 'payments-report',
    name: 'Payments Report',
    description: 'List of all payments with customer information',
    type: 'payments',
    path: '/reports/payments'
  }
];